import { Chip, styled, Tooltip } from '@ethings/ui-toolkit';
import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ThingWithContractData } from './contract-management.types';
import { getContractStatus, statusToChipDefinition } from './contract-management.utils';

interface ContractStatusChipProps {
  fullWidth?: boolean;
  item: ThingWithContractData;
}

interface StyledChipProps {
  fullWidth?: boolean;
}

const StyledChip = styled(Chip)<StyledChipProps>(({ fullWidth }) => ({
  ...(fullWidth ? { width: '100%' } : undefined),
}));

export const ContractListStatusChip: FC<ContractStatusChipProps> = ({ fullWidth, item }) => {
  const { t } = useTranslation(['common']);
  const status = getContractStatus(item.contract.dataSubscription);
  const chipDefinition = statusToChipDefinition[status];
  const labelText = t(chipDefinition.label);
  const chipRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = (): void => {
      if (chipRef.current) {
        const labelElement = chipRef.current.querySelector('.MuiChip-label');
        if (labelElement) {
          setIsTruncated(labelElement.scrollWidth > labelElement.clientWidth);
        }
      }
    };

    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [labelText]);

  return (
    <Tooltip title={isTruncated ? labelText : ''} arrow>
      <StyledChip ref={chipRef} data-testid="status-chip" color={chipDefinition.color} label={labelText} fullWidth={fullWidth} />
    </Tooltip>
  );
};
